export enum socketActions {
    PUBLISHED = "published",
    UN_PUBLISHED = "unpublished",
    UPDATED = "updated",
    LEAVED = "leaved",
    JOINED = "joined",
    DELETED = "deleted",
    IMPORTED = "imported",
}